import { getAuthHeaders, removeAuthHeaders } from './session.js';
import { refreshAccessToken } from './tokenRefresh.js';
import { navigate } from './router.js';

const UNAUTHORIZED_REDIRECT_PATH = '/';

const handleAuthError = (status, message) => {
  removeAuthHeaders();
  if (window.location.pathname !== UNAUTHORIZED_REDIRECT_PATH) {
    const errorMessage = message || 'Authentication required. Please sign in.';
    navigate(
      `${UNAUTHORIZED_REDIRECT_PATH}?error=${encodeURIComponent(errorMessage)}`,
      { replace: true }
    );
  }
};

export const authenticatedFetch = async (url, options = {}, apiUrl) => {
  const makeRequest = async () => {
    const requestOptions = {
      ...options,
      headers: {
        ...options.headers,
        ...getAuthHeaders(),
      },
    };

    const response = await fetch(url, requestOptions);

    // Handle 419 - Token expired
    if (response.status === 419) {
      const newAuthToken = await refreshAccessToken(apiUrl);

      if (newAuthToken) {
        // Token refreshed successfully, retry request
        return makeRequest();
      }

      // Refresh failed
      handleAuthError(419, 'Session expired. Please sign in again.');
      throw new Error('Session expired');
    }

    // Handle 401/403 - Unauthorized
    if (response.status === 401 || response.status === 403) {
      handleAuthError(response.status, 'Unauthorized. Please sign in.');
      throw new Error('Unauthorized');
    }

    return response;
  };

  return makeRequest();
};
